import { clientApi } from './CLIENT';

const url = '/api/dashboard/project-operator';
// eslint-disable-next-line no-return-await
export default async () => await clientApi().get(url).then((data) => data.data).catch((error) => {
  console.log(error?.response?.data);
});
